import ControlType from './ControlType';
import FormControl from './FormControl';

export default class RadioInput extends FormControl<HTMLInputElement> {
  type = ControlType.Radio;
}
